import { request } from "@/api/client";
import { PATHS } from "@/api/constants";

import type { EmailTemplateItem, EmailTemplatesResponse } from "./types";

type ApiEnvelope<T> = { ok: boolean; message?: string; data: T; meta?: any };

export async function listEmailTemplates(): Promise<EmailTemplatesResponse> {
  const res = await request<
    EmailTemplateItem[] | ApiEnvelope<EmailTemplateItem[]>
  >({
    method: "GET",
    url: PATHS.emailTemplates.base,
  });

  if (res && typeof res === "object" && "ok" in res && "data" in res) {
    const env = res as ApiEnvelope<EmailTemplateItem[]>;
    const items = Array.isArray(env.data) ? env.data : [];
    return {
      items,
      total: Number(env.meta?.total ?? items.length),
    };
  }

  const items = Array.isArray(res) ? res : [];
  return {
    items,
    total: items.length,
  };
}
